import {
  ButtonDarkBgGhostStyles,
  ButtonDarkBgStyles,
  ButtonPrimaryGhostStyles,
  ButtonPrimaryStyles,
  ButtonSecondaryGhostStyles,
  ButtonSecondaryStyles,
  ButtonTertiaryGhostStyles,
  ButtonTertiaryStyles,
} from './expressive-button-base.styles';
import { ExpressiveButtonInnerTypes } from './expressive-button-base.types';
import { MDSAnchorButton } from '@midwest/web/button';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const AnchorButtonDarkBgGhost = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonDarkBgGhostStyles}
`;
export const AnchorButtonDarkBg = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonDarkBgStyles}
`;
export const AnchorButtonPrimaryGhost = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonPrimaryGhostStyles}
`;
export const AnchorButtonPrimary = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonPrimaryStyles}
`;
export const AnchorButtonSecondaryGhost = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonSecondaryGhostStyles}
`;
export const AnchorButtonSecondary = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonSecondaryStyles}
`;
export const AnchorButtonTertiaryGhost = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonTertiaryGhostStyles}
`;
export const AnchorButtonTertiary = styled(
  MDSAnchorButton,
)<ExpressiveButtonInnerTypes>`
  ${ButtonTertiaryStyles}
`;
